import * as Types from '../../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddStockTakeLotMutationVariables = Types.Exact<{
  input: Types.AddStockTakeLotInput;
}>;


export type AddStockTakeLotMutation = { readonly __typename?: 'Mutation', readonly addStockTakeLot: { readonly __typename?: 'StockTakeLotAddition', readonly id: string, readonly stockTake: { readonly __typename?: 'StockTake', readonly id: string, readonly aggregateInfo: { readonly __typename?: 'StockTakeAggregateInfo', readonly totalLotCount: number, readonly reviewedLotCount: number } } } };


export const AddStockTakeLotDocument = gql`
    mutation addStockTakeLot($input: AddStockTakeLotInput!) {
  addStockTakeLot(input: $input) {
    id
    stockTake {
      id
      aggregateInfo {
        totalLotCount
        reviewedLotCount
      }
    }
  }
}
    `;
export type AddStockTakeLotMutationFn = Apollo.MutationFunction<AddStockTakeLotMutation, AddStockTakeLotMutationVariables>;

/**
 * __useAddStockTakeLotMutation__
 *
 * To run a mutation, you first call `useAddStockTakeLotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddStockTakeLotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addStockTakeLotMutation, { data, loading, error }] = useAddStockTakeLotMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddStockTakeLotMutation(baseOptions?: Apollo.MutationHookOptions<AddStockTakeLotMutation, AddStockTakeLotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddStockTakeLotMutation, AddStockTakeLotMutationVariables>(AddStockTakeLotDocument, options);
      }
export type AddStockTakeLotMutationHookResult = ReturnType<typeof useAddStockTakeLotMutation>;
export type AddStockTakeLotMutationResult = Apollo.MutationResult<AddStockTakeLotMutation>;
export type AddStockTakeLotMutationOptions = Apollo.BaseMutationOptions<AddStockTakeLotMutation, AddStockTakeLotMutationVariables>;